module.exports = __webpack_public_path__ + "img/award (9).822b57a6.jpg";